import {
  AnalyticsEventProperties,
  AnalyticsEventValue,
  FunnelInfoProperties,
  isExtendedAnalyticsEvent,
  PaymentFormCompletedProperties,
  PaymentFormStateProperties,
} from 'core/analytics/entities';
import { FunnelStepService, SnitcherService } from 'core/analytics/interfaces';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';

export class SnitcherServiceWithFunnelContext implements SnitcherService {
  constructor(
    private readonly snitcherService: SnitcherService,
    private readonly funnelSettingsService: FunnelSettingsServiceInterface,
    private readonly funnelStepService: FunnelStepService,
  ) {}

  trackEvent(event: AnalyticsEventValue, properties: AnalyticsEventProperties = {}) {
    if (!this.funnelSettingsService.hasFunnelContext()) return Promise.resolve();

    const eventName = isExtendedAnalyticsEvent(event) ? event.name : event;
    const eventProperties = isExtendedAnalyticsEvent(event)
      ? { ...event.properties, ...properties }
      : properties;

    return this.snitcherService.trackEvent(eventName, {
      ...eventProperties,
      ...this.getFunnelProperties(),
    });
  }

  trackPaymentFormState(properties: PaymentFormStateProperties) {
    if (!this.funnelSettingsService.hasFunnelContext()) return Promise.resolve();

    return this.snitcherService.trackPaymentFormState({
      ...properties,
      ...this.getFunnelProperties(),
    });
  }

  paymentFormCompleted(properties: PaymentFormCompletedProperties) {
    if (!this.funnelSettingsService.hasFunnelContext()) return Promise.resolve();

    return this.snitcherService.paymentFormCompleted({
      ...properties,
      ...this.getFunnelProperties(),
    });
  }

  trackFunnelInfo(properties: FunnelInfoProperties) {
    if (!this.funnelSettingsService.hasFunnelContext()) return Promise.resolve();

    return this.snitcherService.trackFunnelInfo({
      ...properties,
      ...this.getFunnelProperties(),
    });
  }

  private getFunnelProperties(): AnalyticsEventProperties {
    return {
      funnel_step_number: this.funnelStepService.getStepNumber(),
      screen_id: this.funnelSettingsService.getScreenId(),
      project_id: this.funnelSettingsService.getProjectId(),
      funnel_id: this.funnelSettingsService.getFunnelId(),
      flow_id: this.funnelSettingsService.getFlowId(),
    };
  }
}
